// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

export const DELETE_USER_SETTING = "mondoo.captain.Captain.DeleteUserSetting";
